import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from '../core/rest';

export const GetVideoStatusList = createAsyncThunk(
    "VideoTasks/GetVideoStatusList",
    async (request) => {
        try {
            let videoTypeIds = '';
            if (request.videoTypes.length > 0) {
                videoTypeIds = request.videoTypes.join(',');
            }
            let agencyIdList = '';
            if (request.filterAgencies.length > 0) {
                agencyIdList = request.filterAgencies.join(',');
            }
            let statusIds = '';
            if (request.status.length > 0) {
                statusIds = request.status.join(',');
            }
            const response = await Rest.get(ApiGatewayUrl +
                "/videostatus?page=" + request.page + "&rows_per_page=" + request.rows_per_page
                + "&filterAgencies=" + agencyIdList + "&videoTypes=" + videoTypeIds + "&status=" + statusIds
                + "&filterText=" + request.filter_text
                + "&startDate=" + request.startDate + "&endDate=" + request.endDate
            );
            return response.data;
        } catch (ex) {
            ErrorException(ex.response);
        }

    }
);
export const videoStatusSlice = createSlice({
    name: "videoStatus",
    initialState: {
        videoStatusList: [],
        videoTypeList: [],
        statusList: [],
        total: 0,
    },
    reducers: {
    },

    extraReducers: (builder) => {
        builder
            .addCase(GetVideoStatusList.fulfilled, (state, action) => {
                return {
                    ...state,
                    videoStatusList: action.payload.videoStatusList,
                    videoTypeList: action.payload.videoTypeList,
                    statusList: action.payload.statusList,
                    total: action.payload.total
                }
            })
    }
});

export const videoStatusActions = videoStatusSlice.actions;
export const videoStatusState = (state) => state.videoStatus;
export default videoStatusSlice.reducer;